import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const InboxTable = lazy(
  () =>
    import(/* webpackChunkName: "SherlockRoutes" */ '../risk-inbox/inbox.table')
);

const SherlockEscalationTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../../../pages/sherlock/genericInbox/sherlockEscalationTable'
    )
);

export const generalRoutes: PageRouter[] = [
  {
    name: 'live',
    path: '/live',
    component: InboxTable,
    exact: false,
    tabs: []
  },
  {
    name: 'pending',
    path: '/pending',
    component: InboxTable,
    exact: false,
    tabs: []
  },
  {
    name: 'escalated',
    path: '/escalated',
    component: SherlockEscalationTable,
    exact: false,
    tabs: []
  },

  {
    name: 'archive',
    path: '/archive',
    component: InboxTable,
    exact: false,
    tabs: []
  }
];
